'use client';

import { useEffect, useRef } from 'react';
import { identifyUser } from '@/lib/analytics';

interface AnalyticsUserIdentityProps {
  user: {
    id: string | number;
    email?: string;
    name?: string;
    is_coach?: boolean;
  } | null;
}

/**
 * Component that identifies the user in Google Analytics.
 * Sets user_id and user properties for GA4 reports.
 * Should be placed inside UserProvider context.
 */
export function AnalyticsUserIdentity({ user }: AnalyticsUserIdentityProps) {
  const identified = useRef(false);

  useEffect(() => {
    if (!user || identified.current) return;

    identifyUser({
      id: user.id,
      email: user.email,
      name: user.name,
      is_coach: user.is_coach,
    });

    identified.current = true;
  }, [user]);

  return null;
}
